import { Box } from '@mui/material';
import { useFormContext } from 'react-hook-form';

import { ProjectInputs } from 'src/global/types/project.type';

import { ThemeBackground } from './ThemeBackground';
import { ThemeColor } from './ThemeColor';
import { ThemeDataDisplay } from './ThemeDataDisplay';
import ThemeMode from './ThemeMode';
import { ThemeReferralSection } from './ThemeReferralSection';

export function ThemeSection() {
  const { watch } = useFormContext<ProjectInputs>();
  const watchReferral = watch('referral');
  return (
    <Box width={'100%'}>
      <ThemeMode />
      <ThemeColor />
      <ThemeBackground />
      <ThemeDataDisplay />
      {watchReferral.isEnable ? <ThemeReferralSection /> : null}
    </Box>
  );
}
